import {RefObject} from 'react';
import {useAdjustXAxisScrollPosition} from '../../../common/shared/hooks/useAdjustXAsixScrollPosition';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {OutlinedTabItem} from '../OutlinedTabItem/OutlinedTabItem';
import {BelowTagTabProps} from './BelowTagTabProps.interface';

export function BelowTagTab({
  tagItemList,
  onClickTagItem,
  selectedTagItemParam,
  className,
  ...props
}: BelowTagTabProps) {
  const {tabRef, onSelectTabItem} = useAdjustXAxisScrollPosition(
    tagItemList.findIndex(item => item.param === selectedTagItemParam)
  );

  return (
    <div
      ref={tabRef as RefObject<HTMLDivElement>}
      className={twMerge(
        'flex h-44pxr w-full flex-row items-center space-x-8pxr overflow-x-auto bg-theme-bg-base scrollbar-hide',
        className
      )}
      {...props}
    >
      {tagItemList.map((item, idx) => (
        <OutlinedTabItem
          key={item.param}
          isActive={item.param === selectedTagItemParam}
          className="shrink-0"
          onClick={e => {
            LOG_CLICK_EVENT('키워드_클릭', e, () => {
              onSelectTabItem(e.target as HTMLElement);
              onClickTagItem?.(item.param);
            });
          }}
          {...putTiaraObjectProps({
            click: {
              layer1: '키워드',
              ordnum: String(idx + 1),
              copy: item.name,
            },
          })}
        >
          #{item.name}
        </OutlinedTabItem>
      ))}
    </div>
  );
}
